export default __webpack_public_path__ + "242e1526058c869d0d2efdd5c4a06262.glb";